import WorldData from './world';

export default WorldData;



// WEBPACK FOOTER //
// ./src/index.js